import * as React from 'react';
import { useEffect, useRef } from 'react';

interface Props {
	button: HTMLElement;
}

const Button: React.FC<Props> = ({ button }) => {
	const buttonHandler = useRef<HTMLDivElement>();

	useEffect(() => {
		if (buttonHandler) {
			buttonHandler.current.appendChild(button);
		}
	}, [buttonHandler, button]);

	return <div ref={buttonHandler} />;
};

export default Button;
